export default __webpack_public_path__ + "static/media/concordia.586d2aff.png";